import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fake-progress"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fake-progress__bar" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-circle-play" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-circle-stop" }, null, -1)

import PlayPreviewButton from './PlayPreviewButton.vue'
import { ref, withDefaults, onMounted } from 'vue'

type ComponentProperties = {
  cssClass?: string;
  previewUrl: string;
  playButtonEnabled?: boolean;
  playButtonCssClass?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPreview',
  props: {
    cssClass: { default: 'video-preview' },
    previewUrl: { default: '' },
    playButtonEnabled: { type: Boolean, default: true },
    playButtonCssClass: { default: 'video-preview__play' }
  },
  emits: ['preview-start', 'preview-end', 'preview-error'],
  setup(__props: any, { emit }) {

const props = __props as { cssClass: string, previewUrl: string, playButtonEnabled: boolean, playButtonCssClass: string };





const showProgress = ref<boolean>(false)
const display = ref<boolean>(false)
const isPlayed = ref<boolean>(false)
const deferredPreviewPlayTimer = ref<ReturnType<typeof setTimeout>|null>(null)

// Handle direct click on button
// Starts playing without delay
const startPlay = () => {
  display.value = true
  window.addEventListener('blur', onWindowBlur)
}

const stopPlay = () => {
  display.value = false
  isPlayed.value = false

  removeDeferredTimer()
  window.removeEventListener('blur', onWindowBlur)
}

const previewStartsPlay = () => {
  isPlayed.value = true
}

const previewEndsPlay = () => {
  isPlayed.value = false
}

const previewLoading = () => {
  showProgress.value = true
}

const previewLoaded = () => {
  showProgress.value = false
}

const previewLoadedWithError = () => {
  showProgress.value = false
  display.value = false
  window.removeEventListener('blur', onWindowBlur)
  emit('preview-error')
}
// Handle mouse enter and mouse leave events
const removeDeferredTimer = () => {
  if (deferredPreviewPlayTimer.value !== null) {
    window.clearTimeout(deferredPreviewPlayTimer.value)
    deferredPreviewPlayTimer.value = null
  }
}

const playPreviewWithDelay = () => {
  if (deferredPreviewPlayTimer.value !== null) {
    return
  }

  deferredPreviewPlayTimer.value = setTimeout(() => {
    display.value = true
    window.addEventListener('blur', onWindowBlur)
    removeDeferredTimer()
  }, 400)
}

const onPreviewMouseOver = () => {
  playPreviewWithDelay()
}

const onPreviewMouseOut = (e: MouseEvent & { toElement: HTMLElement }) => {
  const el = e.toElement || e.relatedTarget

  //window.removeEventListener('blur', onWindowBlur)
  removeDeferredTimer()

  if (el && el.nodeName !== 'VIDEO') {
    if (display.value === true) {
      display.value = false
    }
  }
}

const onWindowBlur = () => {
  stopPlay()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.cssClass, {'-video': display.value}]),
    onMouseenter: onPreviewMouseOver,
    onMouseleave: onPreviewMouseOut,
    onBlur: onPreviewMouseOut,
    tabindex: "-1"
  }, [
    (showProgress.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (display.value)
      ? (_openBlock(), _createElementBlock("video", {
          key: 1,
          src: __props.previewUrl,
          muted: "",
          autoplay: "",
          loop: "",
          "webkit-playsinline": "true",
          playsinline: "true",
          onLoadstart: previewLoading,
          onCanplay: previewLoaded,
          onError: previewLoadedWithError,
          onPlay: previewStartsPlay,
          onPause: previewEndsPlay,
          onContextmenu: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent","stop"]))
        }, null, 40, _hoisted_4))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default", {
      onContextmenu: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"]))
    }),
    (props.playButtonEnabled)
      ? (_openBlock(), _createBlock(PlayPreviewButton, {
          key: 2,
          class: _normalizeClass(props.playButtonCssClass),
          "is-play-now": isPlayed.value,
          onStartPlay: startPlay,
          onStopPlay: stopPlay
        }, {
          play: _withCtx(() => [
            _hoisted_5
          ]),
          stop: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["class", "is-play-now"]))
      : _createCommentVNode("", true)
  ], 34))
}
}

})